import { render, staticRenderFns } from "./AppUkPrivacyPolicy.vue?vue&type=template&id=51e2370f&scoped=true"
import script from "./AppUkPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./AppUkPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./AppUkPrivacyPolicy.vue?vue&type=style&index=0&id=51e2370f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2370f",
  null
  
)

export default component.exports